import { render, staticRenderFns } from "./CreateBusiness.vue?vue&type=template&id=4d2cf7ba&scoped=true"
import script from "./CreateBusiness.vue?vue&type=script&lang=js"
export * from "./CreateBusiness.vue?vue&type=script&lang=js"
import style0 from "./CreateBusiness.vue?vue&type=style&index=0&id=4d2cf7ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2cf7ba",
  null
  
)

export default component.exports